module.exports = __webpack_public_path__ + "static/media/linkedin-green.b3eaf771.png";